import QueuesDialog from '@/components/queues/QueuesDialog';
import QueueIcon from '@mui/icons-material/Queue';
import { FC, useState } from 'react';
import StyledTreeItem from './StyledTreeItem';
import TreeLabel from './TreeLabel';

const TreeQueues: FC = () => {
  const [openManager, setOpenManager] = useState(false);

  return (
    <>
      <StyledTreeItem
        itemId='queues'
        label={<TreeLabel icon={QueueIcon} label='Queues' />}
        onClick={() => setOpenManager(true)}
      />
      <QueuesDialog open={openManager} onClose={() => setOpenManager(false)} />
    </>
  );
};

export default TreeQueues;
